<template>
  <div class="share-alert-main">
    <!-- <transition name="opacity">
      <div class="cover" @click="close" v-if="alertData.show && alertData.type === 'shareCv'"></div>
    </transition> -->
    <!-- 简历分享 -->
    <transition name="alert">
      <div class="share-cv" v-if="alertData.show && alertData.type === 'shareCv'">
        <div class="title">微信分享</div>
        <div class="message">微信扫码发送至好友</div>
        <div class="img">
          <img v-if="isShowLoading && url" :src="url" alt="">
          <qrcode-vue v-if="isShowLoading && !url" :value="alertData.shareUrl" :size="180"/>
        </div>
        <div class="url">
          <input class="text" :value="alertData.shareUrl" readonly>
          <button class="btn" :data-clipboard-text="alertData.shareUrl" @click="copy">复制链接</button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import qrcodeVue from 'qrcode-vue';
import Clipboard  from 'clipboard';
import api from '@/api';
export default {
  name: 'shareAlert',
  components: {
    qrcodeVue
  },
  data() {
    return {
      url: '',
      isShowLoading: false
    };
  },
  computed: {
    ...mapState('me', ['isLogin']),
    ...mapState('app', ['alertData']),
    ...mapState('editor', [ 'cvDetail', 'currentInfo', 'profile', 'extras' ]),
    ...mapState('cvs', ['editorCvToken'])
  },
  watch: {
    alertData: {
      deep: true,
      immediate: true,
      handler: async function (alertData) {
        if (!alertData.show) {
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        }else{
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }
        if (alertData.show && alertData.type === 'shareCv') {
          let params = {}
          let res = await api.cvsEditor.cvQr(params, this.cvDetail.basic_info.token || alertData.token);

          if (res.code == 1000){
            let url = res.data.image || '';
            if (url) {
              url = 'data:image/jpeg;base64,' + url;
            }
            this.url = url;
            this.isShowLoading = true;
          }
        }
      }
    }
  },
  methods: {
    close(){
      this.$store.dispatch('app/setAlertData', {
        show: false,
        type: ''
      })
    },
    copy() {
      let clipboard = new Clipboard('.btn');
      clipboard.on('success', e => {
        this.$message.success('复制成功');
        // 释放内存
        clipboard.destroy();
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .share-alert-main {
    font-family:PingFangSC-Medium,PingFang SC;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 0;
    height: 0;
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
      position: fixed;
      top: 0;
      left: 0;
    }
    .share-cv {
      position: fixed;
      top: 80px;
      left: 0;
      right: 0;
      margin: auto;

      width: 338px;
      height: 382px;
      background: #fff;
      border-radius: 6px;
      color: #404040;
      .title {
        padding-top: 36px;
        font-size: 24px;
        text-align: center;

      }
      .message {
        font-size: 14px;
        font-weight: normal;
        color: #666;
        margin-top: 14px;
        text-align: center;
      }
      .img {
        width: 180px;
        height: 180px;
        margin: 30px auto 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .url {
        width: 290px;
        height: 32px;
        border-radius: 16px;
        overflow: hidden;
        margin: 24px auto 0;
        background: #f0f0f0;
        display: flex;
        border: 1px solid #ECECECFF;
        .text {
          flex: 1;
          font-size: 14px;
          background: #fff;
          padding: 0 10px;
          color: #606060FF;
        }
        button {
          width: 80px;
          font-size: 14px;
          font-weight: 500;
          color: #4183FFFF;
          background: #fff;
          border: none;
          border-left: 1px solid #ECECECFF;
        }
      }
    }
  }
</style>

<style lang="scss">
  .share-alert-main {
    .share-cv {
      .img {
        width: 180px;
        height: 180px;
        margin: 30px auto 0;
        img {
          width: 180px!important;
          height: 180px!important;
        }
      }
    }
  }
</style>
